module.exports = function (it) {
  return typeof it === 'object' ? it !== null : typeof it === 'function';
};



// WEBPACK FOOTER //
// webpack:///node_modules/core-js/library/modules/_is-object.js